import React from 'react';
import { BarChartLabel } from './BarChartLabel.esm.js';

const BarChartTick = ({
  x,
  y,
  height,
  width,
  payload,
  visibleTicksCount,
  details
}) => {
  const gutterWidth = 5;
  const labelWidth = width / visibleTicksCount - gutterWidth * 2;
  return /* @__PURE__ */ React.createElement(
    BarChartLabel,
    {
      x,
      y,
      height,
      width: labelWidth,
      details
    },
    !payload.value ? "Unlabeled" : payload.value
  );
};

export { BarChartTick };
//# sourceMappingURL=BarChartTick.esm.js.map
